import ArrowRightIcon from "./ArrowRightIcon";
import styled from "styled-components";
type directionProp = { rotation?: number; color?: string };

const ArrowWrapper = styled.span<directionProp>`
  border-radius: 50%;
  background-color: #e55934;
  padding: 0 0.65em 0 0.65em;
  position: relative;
  width: 1.2em;
  height: 1.2em;
  svg {
    font-size: 0.8em;
    position: absolute;
    ${({ rotation }) => (rotation === 180 ? `left: 0.2em;` : `right: 0.1em;`)}
    top: 0.3em;
  }
`;
const ArrowCircleIcon = ({ rotation }: any) => (
  <ArrowWrapper rotation={rotation}>
    <ArrowRightIcon rotation={rotation} />
  </ArrowWrapper>
);
export default ArrowCircleIcon;
